import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AppResource } from 'src/app/app.resource';
import { CommonModule } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { PopUpInfoVM } from 'src/app/shared/models/model/concretes/components/popup-info.model';
import { Direction } from 'src/app/shared/enum/direction.enum';

@Component({
  selector: 'app-popup-info',
  templateUrl: './popup-info.component.html',
  standalone: true,
  imports: [CommonModule, ButtonModule, OverlayPanelModule]
})
export class PopupInfoComponent extends BaseComponent implements OnInit {
  @Input() popUpInfo!: PopUpInfoVM;
  isImageActive: boolean = false;
  imageSrc: string = this.resource.infobulle.popupInactive;

  // URL des images
  inactiveImage: string = this.resource.infobulle.popupInactive;
  activeImage: string = this.resource.infobulle.popupActive;
  direction = Direction;

  constructor(resources: AppResource) {
    super(resources);
  }

  toggleImage() {
    this.isImageActive = !this.isImageActive;
    this.imageSrc = this.isImageActive ? this.activeImage : this.inactiveImage;
  }
}
